import React from "react";
import { ModalHardwareInstallContext } from "./modal-hardware-install-context";
import { useModalHardwareInstallHook } from "./modal-hardware-install-hooks";
import { ModalHardwareInstallProps } from "../types/index";

export function ContextModalHardwareInstallProvider({
  children,
  controller,
}: {
  children: React.ReactNode;
} & ModalHardwareInstallProps) {
  const value = useModalHardwareInstallHook(controller);

  return (
    <ModalHardwareInstallContext.Provider value={value}>
      {children}
    </ModalHardwareInstallContext.Provider>
  );
}
